module.exports = {
          srcSet: __webpack_public_path__ + "37dd3011ed33014461fdb2f59e9be964-1680.png"+" 1680w",
          images:[ {path: __webpack_public_path__ + "37dd3011ed33014461fdb2f59e9be964-1680.png",width: 1680,height: 541}],
          src: __webpack_public_path__ + "37dd3011ed33014461fdb2f59e9be964-1680.png",
          toString:function(){return __webpack_public_path__ + "37dd3011ed33014461fdb2f59e9be964-1680.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAZ0lEQVR4nBXKsQ0BABRF0dsqhIjSDjoTiAL76CQkIlEotFpL/Ndp2MQABvhXnPpAXBIfpE/EFeWQckQ5pnpGnBIXED/EL/FN3FO9Jh6IF8o78Up8/uOR8kU5IE6IW9Jz4ob0jXgm7n4ixT/8fu+dvwAAAABJRU5ErkJggg==",
          width: 1680,
          height: 541
        }